class Courses {
	constructor (wrapper, coursesDated) {
		this.wrapper = wrapper
		this.coursesDated = coursesDated
		this.formCoursesClose = this.wrapper.querySelector('.form-courses__close')
		this.pages = this.wrapper.querySelectorAll('[data-page]')
		this.pagesLenght = (this.pages.length - 1)
		this.actionNextPage = this.wrapper.querySelector('[data-action="next"]')
		this.actionPrevPage = this.wrapper.querySelector('[data-action="prev"]')
		this.actionSubmit = this.wrapper.querySelector('[data-action="submit"]')
		this.selectCourses = this.wrapper.querySelector('#courses')
		this.selcetdate = this.wrapper.querySelector('#date')
		this.activePage = 0
	}

	// open popuo form courses
	open () {
		this.wrapper.classList.remove('close')
	}

	// close popuo form courses
	close () {
		this.wrapper.classList.add('close')
	}

	// sitch moving pages form courses
	movePage (signpost) {
		switch (signpost) {
		case 'next':
			this.nextPage()
			break
		case 'prev':
			this.prevPage()
			break

		default:
			break
		}

		[...this.pages].forEach(e => {
			if (e.dataset.page == this.activePage) {
				e.classList.add('open', 'move-' + signpost)

				// remove animation
				setTimeout(() => {
					e.classList.remove('move-' + signpost)
				}, 800)
			} else {
				e.className = ''
			}
		})
	}

	// next page form courses
	nextPage () {
		if (this.activePage < this.pagesLenght) { this.activePage++ }
	}

	// prev page form courses
	prevPage () {
		if (this.activePage >= 1) this.activePage--
	}

	// Sort courses
	sortCorses (courses) {
		const newArrayCourses = []
		courses.forEach(el => {

			if (newArrayCourses.find(x => x.course_name == el.course_name)) {
				const index = newArrayCourses.map((e) => e.course_name).indexOf(el.course_name);
				newArrayCourses[index].date.push(this.removeTime(el.date))
			} else {
				const valueData = this.removeTime(el.date)
				el.date = []
				el.date.push(valueData)
				newArrayCourses.push(el)
			}
		})

		return newArrayCourses
	}

	// remove H:M:S (00:00:00)
	removeTime (time) {
		return time.substr(0, time.indexOf(' '))
	}

	// build select courses
	buildSelectCourses () {
		this.coursesDated.forEach(el => {
			const option = document.createElement('option')
			option.value = el.course_name
			option.text = el.course_name
			this.selectCourses.appendChild(option)
		})
		this.selectDeadlinesCourse(this.coursesDated[0].date)
	}

	// Looks for course dates by name. Returns arrays
	dateSearch (courseName) {
		const index = this.coursesDated.map((e) => e.course_name).indexOf(courseName)
		this.selectDeadlinesCourse(this.coursesDated[index].date)
	}

	// rendering select data course
	selectDeadlinesCourse (courseDates) {
		this.selcetdate.innerHTML = ''
		courseDates.forEach(el => {
			const option = document.createElement('option')
			option.value = el
			option.text = el
			this.selcetdate.appendChild(option)
		})
	}

	init () {
		this.actionNextPage.addEventListener('click', () => this.movePage(this.actionNextPage.dataset.action))
		this.actionPrevPage.addEventListener('click', () => this.movePage(this.actionPrevPage.dataset.action))
		this.formCoursesClose.addEventListener('click', () => this.close())
		this.selectCourses.addEventListener('change', (e) => this.dateSearch(e.target.value))
		this.coursesDated = this.sortCorses(this.coursesDated)
		this.buildSelectCourses()
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const wrapper = document.getElementById('courses-main')
	window.courses = new Courses(wrapper, coursesDated)
	window.courses.init()
})



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/courses-main/script.js